import React, { useEffect } from 'react'
import { RootState, Dispatcher } from 'AppTypes'
import { connect } from 'react-redux'
import playRed from '@app/layouts/html/assets/img/Polygon-61.png'
import tabetai from '@app/layouts/html/assets/img/gmts-kun_icon_moji_tabetai_20px.png'
import iine from '@app/layouts/html/assets/img/gmts-kun_icon_moji_iine_20px.png'
import ikitai from '@app/layouts/html/assets/img/gmts-kun_icon_moji_ikitai_20px.png'

import * as actions from '../state_management/actions'

const mapStateToProps = (state: RootState) => ({
  countLiked: state.store.countLiked,
  countWantToEat: state.store.countWantToEat,
  countWantToTry: state.store.countWantToTry
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  fetchStoreVideoGoLiverSummary: (params: any) => dispatch(actions.fetchStoreVideoGoLiverSummary(params))
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & ReturnType<any>

const VideoGoLiverSummary: React.FC<Props> = ({
  countLiked,
  countWantToEat,
  countWantToTry,
  fetchStoreVideoGoLiverSummary,
  id
}) => {
  useEffect(() => {
    fetchStoreVideoGoLiverSummary({ StoreId: id })
  }, [fetchStoreVideoGoLiverSummary, id])

  return (
    <>
      <h4><img src={playRed} alt="" />動画評価(合計)</h4>
      <div className="d-flex justify-content-center">
        <div className="text-center me-3 ms-3">
          <img src={tabetai} alt="" />
          <p>{countWantToEat}</p>
        </div>
        <div className="text-center me-3 ms-3">
          <img src={ikitai} alt="" />
          <p>{countWantToTry}</p>
        </div>
        <div className="text-center me-3 ms-3">
          <img src={iine} alt="" />
          <p>{countLiked}</p>
        </div>
      </div>
    </>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoGoLiverSummary)
